import { Button, Flex, Form, Input, Modal } from "antd";
import React from "react";

interface InviteTeamMemberModalProps {
  inviteModalOpen: boolean;
  setInviteModalOpen: (open: boolean) => void;
  handleInviteUser: (values: { email: string }) => void;
  defaultEmail: string;
}

const InviteTeamMemberModal: React.FC<InviteTeamMemberModalProps> = ({
  defaultEmail,
  handleInviteUser,
  inviteModalOpen,
  setInviteModalOpen,
}) => {
  return (
    <Modal
      title={"Invite Team Member"}
      open={inviteModalOpen}
      onCancel={() => setInviteModalOpen(false)}
      footer={null}
      destroyOnClose
      centered
      width={400}
    >
      <Form
        name="inviteTeamMemberForm"
        onFinish={handleInviteUser}
        layout="vertical"
        initialValues={{ email: defaultEmail }}
        scrollToFirstError
        autoComplete="off"
      >
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              type: "email",
              message: "Please enter a valid email address!",
            },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Flex align="center" justify="space-between" gap={16}>
          <Button block size="middle" onClick={() => setInviteModalOpen(false)}>
            Cancel
          </Button>
          <Button block size="middle" type="primary" htmlType="submit">
            Invite
          </Button>
        </Flex>
      </Form>
    </Modal>
  );
};

export default InviteTeamMemberModal;
